<template>
  <section>
    <edm-list :query="query" />
  </section>
</template>

<script>
import EdmList from '@/components/company/EdmList'

export default {
  name: 'Edm',
  components: {
    EdmList
  },

  data() {
    const { query } = this.$route

    return {
      query: query
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  }
}
</script>
